import React, { Component } from "react";
import { withRequest } from "../../utils/request";

class Form extends Component {
    state = {
        grupos: [],
        almacenes: [],
        inventariable: true,
        cantidad: 0,
    };
    componentDidMount() {
        this.getTable("grupos");
        this.getTable("almacenes");

        this.setState({
            inventariable: this.props.item.nombre
                ? this.props.item.inventariable
                : true,
        });
    }
    getTable = async (url = null) => {
        const table = await this.props.request(url);

        if (table.data) {
            this.setState({
                [url]: table.data,
                loading: false,
            });
        }
    };
    onChangeInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };
    onChangeCheckbox = (e) => {
        this.setState({
            [e.target.name]: e.target.checked,
        });
    };
    render() {
        const { item, errors } = this.props;
        const { grupos, almacenes, inventariable, cantidad } = this.state;
        return (
            <div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Nombre:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='nombre'
                            name='nombre'
                            defaultValue={item.nombre}
                        />
                        {errors.nombre && (
                            <small className='help-blockParams form-Text'>
                                {errors.nombre[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Referencia:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='referencia'
                            name='referencia'
                            defaultValue={item.referencia}
                        />
                        {errors.referencia && (
                            <small className='help-blockParams form-Text'>
                                {errors.referencia[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Estado:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <select
                            type='text'
                            className='text-input form-control'
                            id='estado'
                            name='estado'
                            defaultValue={item.estado}>
                            <option value='nuevo'>Nuevo</option>
                            <option value='usado'>Usado</option>
                        </select>
                        {errors.estado && (
                            <small className='help-blockParams form-Text'>
                                {errors.estado[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Costo:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='number'
                            className='text-input form-control'
                            id='costo'
                            name='costo'
                            step='0.01'
                            defaultValue={item.costo}
                        />
                        {errors.costo && (
                            <small className='help-blockParams form-Text'>
                                {errors.costo[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Inventariable
                        </label>
                    </div>
                    <div className='col-md-7'>
                        <label className='switch switch-3d switch-success mr-3'>
                            <input
                                type='hidden'
                                name='inventariable'
                                value='no'
                            />
                            <input
                                type='checkbox'
                                className='switch-input'
                                name='inventariable'
                                value='yes'
                                onChange={this.onChangeCheckbox}
                                defaultChecked={
                                    item.id ? item.inventariable : inventariable
                                }
                            />
                            <span className='switch-label' />
                            <span className='switch-handle' />
                        </label>
                    </div>
                </div>
                {inventariable ? (
                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>
                                Cantidad:
                            </label>
                        </div>
                        <div className='col col-md-7'>
                            <input
                                type='number'
                                className='text-input form-control'
                                id='cantidad'
                                name='cantidad'
                                step='0.01'
                                onChange={this.onChangeInput}
                                value={cantidad ? cantidad : item.cantidad}
                            />
                            {errors.cantidad && (
                                <small className='help-blockParams form-Text'>
                                    {errors.cantidad[0]}
                                </small>
                            )}
                        </div>
                    </div>
                ) : (
                    <input type='hidden' name='cantidad' value='0' />
                )}
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Unidad:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <select
                            type='text'
                            className='text-input form-control'
                            id='unidad'
                            name='unidad'
                            defaultValue={item.unidad}>
                            <option value='UND'>UND</option>
                            <option value='JUEGO'>JUEGO</option>
                            <option value='PIES'>PIES</option>
                            <option value='PULG'>PULG</option>
                            <option value='MTS'>MTS</option>
                            <option value='CM'>CM</option>
                            <option value='GLS'>GLS</option>
                            <option value='LATA'>LATA</option>
                            <option value='CUBETA'>CUBETA</option>
                            <option value='CUARTOS'>CUARTOS</option>
                            <option value='LITROS'>LITROS</option>
                            <option value='LBS'>LBS</option>
                            <option value='KGS'>KGS</option>
                        </select>
                        {errors.unidad && (
                            <small className='help-blockParams form-Text'>
                                {errors.unidad[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Descripción:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <textarea
                            className='text-input form-control'
                            id='descripcion'
                            name='descripcion'
                            rows='4'
                            defaultValue={item.descripcion}
                        />
                        {errors.descripcion && (
                            <small className='help-blockParams form-Text'>
                                {errors.descripcion[0]}
                            </small>
                        )}
                    </div>
                </div>
                {grupos.length > 0 && (
                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>
                                Grupo:
                            </label>
                        </div>
                        <div className='col col-md-7'>
                            <select
                                className='text-input form-control'
                                id='grupo_id'
                                name='grupo_id'
                                rows='4'
                                defaultValue={
                                    item.grupo ? item.grupo.id : false
                                }>
                                <option value=''>- Seleccionar -</option>
                                {grupos.map((grupo) => (
                                    <option key={grupo.id} value={grupo.id}>
                                        {grupo.nombre}
                                    </option>
                                ))}
                            </select>
                            {errors.grupo_id && (
                                <small className='help-blockParams form-Text'>
                                    {errors.grupo_id[0]}
                                </small>
                            )}
                        </div>
                    </div>
                )}
                {almacenes.length > 0 && (
                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>
                                Almacen:
                            </label>
                        </div>
                        <div className='col col-md-7'>
                            <select
                                className='text-input form-control'
                                id='almacen_id'
                                name='almacen_id'
                                rows='4'
                                defaultValue={
                                    item.almacen ? item.almacen.id : false
                                }>
                                <option value=''>- Seleccionar -</option>
                                {almacenes.map((almacen) => (
                                    <option key={almacen.id} value={almacen.id}>
                                        {almacen.nombre}
                                    </option>
                                ))}
                            </select>
                            {errors.almacen_id && (
                                <small className='help-blockParams form-Text'>
                                    {errors.almacen_id[0]}
                                </small>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withRequest(Form);
